//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { copy } from '@/common/utils/'
export default{
  data() {
    return {
      show: false
    }
  },
  created() {

  },
  methods: {
    handleCopy($id){
      const ele = document.getElementById($id)
      if (copy(ele)) this.$showToast({ text: this.$t('others').copySuceess, time: 2000, type: 'success' })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/build821/views/home/components/contact.vue